/* 22natiON wishlist (per-browser, localStorage). Heart toggles, header count, wishlist grid. */
(function(){
  var KEY='n22_wishlist';
  function read(){ try{ return JSON.parse(localStorage.getItem(KEY))||[]; }catch(e){ return []; } }
  function write(a){ try{ localStorage.setItem(KEY, JSON.stringify(a)); }catch(e){} }
  function has(h){ return read().indexOf(h)!==-1; }
  function toggle(h){ var a=read(); var i=a.indexOf(h); if(i===-1){a.push(h);}else{a.splice(i,1);} write(a); sync(); return i===-1; }
  function addMany(hs){ var a=read(); (hs||[]).forEach(function(h){ if(h && a.indexOf(h)===-1) a.push(h); }); write(a); sync(); }
  function count(){ return read().length; }
  function sync(){
    var list=read();
    document.querySelectorAll('.n22-wish').forEach(function(b){ var h=b.getAttribute('data-handle'); var on=list.indexOf(h)!==-1; b.classList.toggle('is-active', on); b.setAttribute('aria-pressed', on?'true':'false'); });
    document.querySelectorAll('.n22-wish-count').forEach(function(el){ var c=list.length; el.textContent=c; el.hidden = c===0; });
  }
  function money(c){ try{ return '$'+(c/100).toFixed(2); }catch(e){ return ''; } }
  function imgUrl(u){ if(!u) return ''; if(u.indexOf('//')===0) u='https:'+u; return u + (u.indexOf('?')!==-1?'&':'?') + 'width=600'; }
  function renderGrid(id){
    var el=document.getElementById(id||'n22-wishlist-grid'); if(!el) return;
    var list=read(); var empty=document.getElementById('n22-wishlist-empty');
    if(!list.length){ el.innerHTML=''; if(empty) empty.hidden=false; return; }
    if(empty) empty.hidden=true; el.innerHTML='';
    list.forEach(function(h){
      fetch('/products/'+h+'.js').then(function(r){ return r.ok?r.json():null; }).then(function(p){
        if(!p) return;
        var src=imgUrl(p.featured_image || (p.images && p.images[0]) || '');
        var card=document.createElement('div'); card.className='n22-wl-card';
        card.innerHTML='<a class="n22-wl-card__link" href="/products/'+h+'"><div class="n22-wl-card__media"><img src="'+src+'" alt="" loading="lazy"></div><div class="n22-wl-card__title">'+p.title+'</div><div class="n22-wl-card__price">'+money(p.price)+'</div></a><button type="button" class="n22-wl-remove n22-wish is-active" data-handle="'+h+'" aria-label="Remove from wishlist">Remove</button>';
        el.appendChild(card);
      }).catch(function(){});
    });
  }
  document.addEventListener('click', function(e){
    var b=e.target.closest && e.target.closest('.n22-wish'); if(!b) return;
    e.preventDefault(); e.stopPropagation();
    toggle(b.getAttribute('data-handle'));
    if(document.getElementById('n22-wishlist-grid')) renderGrid();
  });
  window.n22Wishlist={read:read,has:has,toggle:toggle,addMany:addMany,count:count,sync:sync,renderGrid:renderGrid};
  if(document.readyState!=='loading') sync(); else document.addEventListener('DOMContentLoaded', sync);
})();
